import { ISidebarState } from '../types/sidebar-state.types';

export const resetSidebarState = (sidebarState: ISidebarState): void => {
    sidebarState.setApprovedExpenseTypes(new Set());
    if (sidebarState.setApprovedLineItemIds) {
        sidebarState.setApprovedLineItemIds(new Set());
    }
    sidebarState.setActiveExpenseType(null);
    sidebarState.setActiveExpenseTypeFileIndex(new Map());
};

